// src/lib/supabase.js
// Replace these with your actual Supabase project values from supabase.com
import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL || 'YOUR_SUPABASE_URL'
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY || 'YOUR_SUPABASE_ANON_KEY'

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY)

// ─── Auth helpers ──────────────────────────────────────────────
export const signUp = (email, password) =>
  supabase.auth.signUp({
    email,
    password,
    options: {
      emailRedirectTo: 'https://www.disdownrange.org/app'
    }
  })

export const signIn = (email, password) =>
  supabase.auth.signInWithPassword({ email, password })

export const signOut = () =>
  supabase.auth.signOut()

export const getUser = () =>
  supabase.auth.getUser()

// ─── Rifle Profiles ────────────────────────────────────────────
export const getRifleProfiles = async (userId) => {
  const { data, error } = await supabase
    .from('rifle_profiles')
    .select('*')
    .eq('user_id', userId)
    .order('created_at', { ascending: false })
  return { data, error }
}

export const saveRifleProfile = async (profile) => {
  const { data, error } = await supabase
    .from('rifle_profiles')
    .upsert(profile)
    .select()
  return { data, error }
}

export const deleteRifleProfile = async (id) => {
  const { error } = await supabase
    .from('rifle_profiles')
    .delete()
    .eq('id', id)
  return { error }
}

// ─── Subscription ──────────────────────────────────────────────
export const getSubscriptionTier = async (userId) => {
  const { data, error } = await supabase
    .from('subscriptions')
    .select('tier')
    .eq('user_id', userId)
    .single()
  return data?.tier || 'free'
}
